module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-16.c4e14d9e.png";